import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiPostMultipart,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Product',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Product',
        href: '/adm/product',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    totalRows: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_product',
    sortDesc: true,
    fields: [
      {
        key: 'no',
        label: 'No',
        thStyle: {
          width: '50px',
        },
      },
      {
        key: 'prod_img',
        label: 'Image',
        sortable: true,
      },
      {
        key: 'prod_code',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'prod_name',
        label: 'Name',
        sortable: true,
      },
      {
        key: 'prod_price',
        label: 'Harga Jual',
        sortable: true,
      },
      {
        key: 'prod_primer',
        label: 'Harga Primer',
        sortable: true,
      },
      {
        key: 'prod_sekunder',
        label: 'Harga Sekunder',
        sortable: true,
      },
      {
        key: 'prod_unit',
        label: 'Unit',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      dist_code: '',
      dist_company: '',
      dist_address: '',
      dist_email: '',
      dist_phone: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeProduct(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchProduct(context, params = null) {
    let result = await ApiGetRequest(`product`, params);
    return !result.error ? result.data.object : [];
  },

  async getListProduct({ commit, state }) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`product`, params);
    commit('changeProduct', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailProduct({ commit }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiGetRequest(`product/${payload.id}`);
    commit('changeProduct', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async uploadImageProduct({ commit, state }, payload) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`upload-image`, payload);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      commit('changeProduct', {
        form: {
          ...data.form,
          prod_img: result.data.object.path,
        },
      });

      return true;
    }

    return false;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeProduct', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`product/import`, {
      items: data.import_form || [],
    });

    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createProduct({ commit, state, dispatch }) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiPostRequest(`product`, state.data.form);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateProduct({ commit, state, dispatch }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiPutRequest(`product/${payload.id}`, state.data.form);

    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteProduct({ commit, dispatch }, payload = null) {
    commit('changeProduct', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`product/${payload.id}`);
    commit('changeProduct', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
